export default __webpack_public_path__ + "static/media/twitter.aee94fec.svg";